import { useState } from 'react';
import PageHeader from '../components/PageHeader.jsx';
import SchainTab from '../components/supply-quality/SchainTab.jsx';
import SellerAccountsTab from '../components/supply-quality/SellerAccountsTab.jsx';
import SupplyAuthorizationsTab from '../components/supply-quality/SupplyAuthorizationsTab.jsx';
import IvtRulesPoliciesTab from '../components/supply-quality/IvtRulesPoliciesTab.jsx';
import TrafficQualityReportingTab from '../components/supply-quality/TrafficQualityReportingTab.jsx';

// Supply Quality & Transparency workstream (Kunal's 2026-09-04 mandate) -- operator-facing
// surface for config-backend's three pillars (see claude/supply-quality-transparency-ivt-
// assessment.md for the full design rationale): schain / supply-chain transparency, ads.txt /
// app-ads.txt / sellers.json, and IVT / bot / traffic quality. One page, five flat tabs --
// mirrors PublisherDetailPage's tab pattern rather than nesting tabs within tabs, since each area
// here is genuinely distinct (different tables, different backend routers) but none is large
// enough on its own to deserve a separate top-level nav entry.
const TABS = [
  { key: 'schain', label: 'Schain' },
  { key: 'sellers', label: 'Seller Accounts & sellers.json' },
  { key: 'supply-auth', label: 'Supply Authorizations' },
  { key: 'ivt', label: 'IVT Rules & Policies' },
  { key: 'reporting', label: 'Traffic Quality Reporting' },
];

export default function SupplyQualityPage() {
  const [tab, setTab] = useState('schain');

  return (
    <div className="page">
      <PageHeader
        title="Supply Quality"
        subtitle="Supply-chain transparency (schain), ads.txt/app-ads.txt/sellers.json, and IVT / traffic quality controls."
      />

      <div className="tabs">
        {TABS.map((t) => (
          <button key={t.key} className={`tabs__tab${tab === t.key ? ' tabs__tab--active' : ''}`} onClick={() => setTab(t.key)}>
            {t.label}
          </button>
        ))}
      </div>

      <div className="tab-panel">
        {tab === 'schain' && <SchainTab />}
        {tab === 'sellers' && <SellerAccountsTab />}
        {tab === 'supply-auth' && <SupplyAuthorizationsTab />}
        {tab === 'ivt' && <IvtRulesPoliciesTab />}
        {tab === 'reporting' && <TrafficQualityReportingTab />}
      </div>
    </div>
  );
}
